/**
 * 站点级固定信息。**ICP 备案号必须与工信部（beian.miit.gov.cn）查到的完全一致**——
 * 淘宝联盟这类媒体备案会逐字比对"网站底部展示的号"和"工信部登记的号"，差一个字符就审核拒绝。
 * 换域名/换备案主体时只改这里一处。
 */
export const SiteConfig = {
  /** 工信部 ICP 备案号；留空则底部不显示备案区块（宁可不显示，也不显示错的） */
  icp: '粤ICP备18097134号-1',
  /** 备案查询官网，规范要求备案号必须链到这里 */
  icpLink: 'https://beian.miit.gov.cn/',
};
